import { fixedAssets } from 'src/containers/PreCache'
import { COLORS, SIZES } from 'src/styles/theme'
import styled from 'styled-components'

export const LoginPageStyle = styled.section`
  position: fixed;
  max-height: 100%;
  text-align: center;
  color: white;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  background: url(${fixedAssets.entranceBg});
  background-size: cover;
  background-position: center;
 
  .action-text {
    cursor: pointer;
  }
  #myVideo {
    position: fixed;
    right: 0;
    bottom: 0;
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    object-fit: cover;
  }
  .mobile-show {
    display: none;
    height: 50vh;
    top: -25%;
    object-fit: scale-down;
  }
  .titleImage {
    position: fixed;
    top: 0%;
    left: 0%;
  }
  .visual {
    position: fixed;
    width: 18%;
  }
  #growth {
    top: 35%;
    left: 2%;
    animation: growthRotate 4s forwards;
  }
  #comfort {
    top: 45%;
    left: 80%;
    animation: comfortRotate 4s forwards;
  }
  #cognition {
    top: 80%;
    left: 47%;
    animation: cognitionRotate 4s forwards;
  }
  #spacerock {
    top: 100%;
    left: 100%;
    width: 25%;
    animation: rockEnter 4s forwards;
  }
  #formContainer {
    position: fixed;
    top: 40%;
    left: 0%;
    right: 0%;
    margin: auto;
    max-width: 600px;
    color: #404040;
    opacity: 0;
    animation: appearMiddle 1s 3s forwards;
    .flexBox {
      display: flex;
      align-items: center;
    } 
    img {
      position: relative;
      height: 375px;
      max-width: 600px;
    }
    #inputContainer {
      position: absolute;
      top: 10%;
      width: 100%;
    }
    label {
      color: #fff;
      font-weight: 500;
      display: block;
      font-size: 14px;
      text-align: center;
      margin-top: 20px;
    }
    input {
      width: 70%;
      background: ${COLORS.lightGray};
      border: none;
      padding: 6px 20px;
      border-radius: 0px;
      font-size: 14px;
      text-align: center;
      font-weight: 500;

      &::placeholder {
        color: ${COLORS.lightGray1};
      }
    }
    .login-btn {
      margin: auto;
      margin-top: 0.5em;
      margin-bottom: 1em;
      border-radius: 12px;
      letter-spacing: 1px;
      background: #FA7F25;
      cursor: pointer;
      width: 40%;

      input[type="submit"] {
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        background: transparent;
        padding: 0;
        border: none;
        margin: 0;
      }
    }
  }

  ${SIZES.mobile} {
    #myVideo {
      display: none;
    }
    .mobile-show {
      display: block;
    }
    .visual {
      width: 30%;
    }
    #formContainer {
      top: 30%;
      .login-btn {
        width: 70%;
      }
    }
  }
`
